import { useMemo } from 'react'
import { com } from '@eidu/form'
import EntityRepository from './EntityRepository'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type UseEntityRepositoryParams = {
  typeId: EntityTypeId | undefined
  types: ReadonlyMap<EntityTypeId, EntityType>
  searchQuery?: string
  pageSize?: number
}

const useEntityRepository = (
  { typeId, types, searchQuery, pageSize = 10 }: UseEntityRepositoryParams,
  deps?: readonly unknown[]
): EntityRepository => {
  return useMemo(
    () => new EntityRepository({ typeId, types, searchQuery, pageSize }),
    [typeId, types, searchQuery, pageSize, ...(deps ?? [])]
  )
}

export default useEntityRepository
